import { useCallback, useRef, useState } from 'react';

/**
 * Tracks the number of columns a CSS grid currently renders, so components can size their content
 * to breakpoints (media/container queries) that are defined only in the CSS. Returns a callback ref
 * for the grid element and the column count (`initial` until the grid has been measured).
 */
export const useGridColumns = (initial: number): [(el: HTMLElement | null) => void, number] => {
  const [cols, setCols] = useState(initial);
  const observer = useRef<ResizeObserver | undefined>(undefined);
  const ref = useCallback((el: HTMLElement | null) => {
    observer.current?.disconnect();
    if (!el || typeof ResizeObserver == 'undefined') return;
    observer.current = new ResizeObserver(() => setCols(getComputedStyle(el).gridTemplateColumns.split(' ').length));
    observer.current.observe(el);
  }, []);
  return [ref, cols];
};
